import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CrudServiceService } from '../../../app/app-services/crud-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    public info: any       = {};
    public pages           = [];
    public socialMedia     = [];
    public organiztionInfo = {
        socialMedia : null,
        description: null
    };
    public categoryList    = [];

    constructor(private crud: CrudServiceService,
        private router: Router,
        private toastr: ToastrService) {
        this.getInfo()
    }

    ngOnInit() {
        this.getCaterories();
    }

    //category List
    public getCaterories() {
        this.crud.getData("category/list").subscribe((res: any) => {
            this.categoryList = res.categories;             
        }, error => {
            this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
        });
    }

    public getCatId(id) {
        let body = {
            catId: id,
            subCatId: null
        }        
        this.router.navigate(['/collectionByCategory/' + id])
    }

    public getInfo() {
        this.crud.getData("merchant/organization/info").subscribe((res: any) => {
            if (res.responseCode == "200") {
                //console.log("footer", res)
                this.info = res.organization;
                this.pages =  res.pages;
                this.organiztionInfo.socialMedia = res.socialMedia;
                this.organiztionInfo.description = res.description;
            }
        })
    }
}
